import { i18n } from 'i18next';
import {
  defaultLocale,
  LanguageCode,
  languages,
  LanguageTag,
  locales,
} from './config';
import { i18next } from './intl/init';

export function getLocaleFromi18nLanguage(language: string) {
  return getLocalesAsArray().find(locale => locale.i18nLocale === language);
}

export function getLocalesAsArray() {
  return Object.values(locales);
}

export function getLanguageTagArray() {
  return Object.keys(locales);
}

export function getDefaultLocale() {
  return defaultLocale;
}

export function getCurrentLanguage({ language }: i18n = i18next) {
  if (language in locales) {
    return locales[language as LanguageTag];
  }
  return defaultLocale;
}

export function getLanguageOptions() {
  return getLocalesAsArray()
    .filter(({ tag }) => tag !== defaultLocale.tag)
    .map(locale => ({
      label: locale.name,
      value: locale.tag,
      coverPreview: locale.label,
    }));
}

export function getPreviewLanguage(input: LanguageTag): string | undefined {
  if (input === locales['it-IT'].tag) {
    return locales['it-IT'].label;
  }

  return getLanguageOptions().find(option => option.value === input)
    ?.coverPreview;
}

export function getLocaleByTag(tag: LanguageTag) {
  return locales[tag];
}

export function getLocaleByLanguageCode(language: LanguageCode) {
  return getLocalesAsArray().find(locale => locale.i18nLocale === language)!;
}

export function isLanguageCode(value: string): value is LanguageCode {
  return languages.includes(value as LanguageCode);
}

export function isLanguageTag(value: string): value is LanguageTag {
  return value in locales;
}
